import { useId } from 'react';
import { MeshGradient } from '@paper-design/shaders-react';

/*
 * The animated mesh-gradient fill used inside SVG shapes (the crest, the title, the lock, the copy).
 * Chrome/Firefox: the WebGL mesh in a <foreignObject>, clipped or masked to the shape.
 * WebKit (Safari and every iOS browser) draws a clipped/masked <foreignObject> as a loose square,
 * so there it's an SVG-native fill: a solid base (in case gradients drop) under the same tones as a gradient.
 */
export const IS_WEBKIT = typeof navigator !== 'undefined'
  && (/Apple/.test(navigator.vendor ?? '') || /[?&]webkit=1\b/.test(location.search)); // ?webkit=1 previews it elsewhere

export function MeshFill({ x = 0, y = 0, width, height, colors, speed = 0.2, distortion = 0.4, swirl = 0.4, clipPath, mask }: {
  x?: number; y?: number; width: number; height: number; colors: string[];
  speed?: number; distortion?: number; swirl?: number; clipPath?: string; mask?: string;
}) {
  const gid = `mesh${useId().replace(/:/g, '')}`;
  if (IS_WEBKIT) {
    return (
      <g clipPath={clipPath} mask={mask}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            {colors.map((c, i) => <stop key={i} offset={`${Math.round((i / Math.max(1, colors.length - 1)) * 100)}%`} stopColor={c} />)}
          </linearGradient>
        </defs>
        <rect x={x} y={y} width={width} height={height} fill={colors[0]} />
        <rect x={x} y={y} width={width} height={height} fill={`url(#${gid})`} />
      </g>
    );
  }
  return (
    <foreignObject x={x} y={y} width={width} height={height} clipPath={clipPath} mask={mask}>
      <div style={{ width, height }}>
        <MeshGradient width={width} height={height} colors={colors} speed={speed} distortion={distortion} swirl={swirl} grainMixer={0} grainOverlay={0} />
      </div>
    </foreignObject>
  );
}
